import { useNavigate } from 'react-router-dom'
import { useCallback, useRef, useEffect } from 'react'
import { getFailPluginLog } from '@/api/web-create-task'

export const useTaskDetailHandlers = (
  id: string,
  taskId: string,
  setTimeId: (id: string) => void,
  getEchartsData: (resultId?: string) => void,
  refreshRequest: (resultId?: string) => void,
  generateReport: (params: any) => Promise<any>,
  deleteTask: (params: any) => Promise<any>,
  setFailLogInfo: (info: any) => void,
  updateResourceInterceptStatus: (params: any) => Promise<any>,
  setRandom: (value: number) => void,
  setSelectedRowKeys: (keys: string[]) => void,
  getUseCaseList: (params: any) => Promise<any>,
  setUseCaseList: (list: any[]) => void,
  setUseCaseTotal: (total: number) => void,
  setFixPayloadCount: (count: number) => void,
  getResultPluginDetail: (params: any) => Promise<any>,
  setPluginDetail: (detail: any) => void,
  setDetailDrawerVisible: (visible: boolean) => void,
  setCardActive: (id: string) => void,
  failedCaseList: any[],
  setId: (id: string) => void,
) => {
  const navigate = useNavigate()
  const failedCaseListRef = useRef(failedCaseList)

  // 更新 ref 的值
  useEffect(() => {
    failedCaseListRef.current = failedCaseList
  }, [failedCaseList])

  const handleToggleTime = (timeId: string) => {
    setTimeId(timeId)
    getEchartsData(timeId)
    refreshRequest(timeId)
    setId(timeId)
  }

  const handleBack = () => {
    navigate('/validation/network/webgateway?tab=task')
  }

  const createReport = (values: any, name: string) =>
    generateReport({
      task_list: [{ task_name: name, campaign_id: id }],
      ...values,
    })
      .then(() => {
        window.open('/report/task/task-report?tab=2', '_self')
      })
      .catch(() => {})

  const handleDelete = async () => {
    try {
      if (id) {
        await deleteTask({ result_id_list: [id] })
        navigate('/validation/network/webgateway?tab=task')
      }
    } catch (error) {
      // Handle error
    }
  }

  const handleExpand = useCallback(() => {
    getFailPluginLog({ result_id: id })
      .then(res => {
        const content = res.data.items.map((item: any) => ({
          key: item.id,
          label: item.case_name,
          children: item.failed_reason,
        }))
        setFailLogInfo((origin: any) => ({ ...origin, content }))
      })
      .catch(() => {})
  }, [id, setFailLogInfo])

  const handleFixed = (
    values: any,
    selectedRowKeys: string[],
    form: any,
    getTaskInfo: (params: any) => Promise<any>,
  ) => {
    const { interceptStatus } = values

    return updateResourceInterceptStatus({
      id: id,
      list: {
        taskResultResourceList: selectedRowKeys.map(key => ({
          resourceId: key,
          interceptStatus:
            interceptStatus === 'intercept_no_verification'
              ? 'intercept_status_intercept_cancel'
              : interceptStatus,
        })),
      },
    })
      .then(() => {
        setRandom(new Date().getTime())
        form.resetFields()
        setSelectedRowKeys([])
        const params = {}
        return getUseCaseList({ result_id: id, task_id: taskId, ...params })
          .then(res => {
            setUseCaseList(res.data.items)
            setUseCaseTotal(res.data.show_total)
            setFixPayloadCount(res.data.manual_correct_count)
            getTaskInfo({ resultId: id, taskId: taskId }).catch(() => {})
          })
          .catch(() => {})
      })
      .catch(() => {})
  }

  const handleChecked = (
    e: any,
    cardId: string,
    selectedRowKeys: string[],
    setSelectedRowKeysFn: (keys: string[]) => void,
  ) => {
    let newSelectedRowKeys = [...selectedRowKeys]
    const selectedkey = e[0]
    if (!selectedkey) {
      newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== cardId)
    } else {
      if (newSelectedRowKeys.includes(selectedkey)) {
        newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== selectedkey)
      } else {
        newSelectedRowKeys.push(selectedkey)
      }
    }
    setSelectedRowKeysFn(newSelectedRowKeys)
  }

  const handleActive = (e: any, key: string) => {
    if (e.target.className === 'ant-checkbox-input') return
    getDrawerData(key)
    setCardActive(key)
  }

  const getDrawerData = (taskPayloadId: string) => {
    setDetailDrawerVisible(true)
    getResultPluginDetail({
      result_id: id || '',
      id: taskPayloadId,
    })
      .then(res => {
        setPluginDetail(res?.data)
      })
      .catch(() => {})
  }

  return {
    handleToggleTime,
    handleBack,
    createReport,
    handleDelete,
    handleExpand,
    handleFixed,
    handleChecked,
    handleActive,
    getDrawerData,
  }
}
